import { render, staticRenderFns } from "./upload-internal-doc.vue?vue&type=template&id=560268d3&scoped=true&"
import script from "./upload-internal-doc.vue?vue&type=script&lang=js&"
export * from "./upload-internal-doc.vue?vue&type=script&lang=js&"
import style0 from "./upload-internal-doc.vue?vue&type=style&index=0&id=560268d3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "560268d3",
  null
  
)

export default component.exports